import React,{useEffect} from "react";
import {connect} from 'react-redux'
import { removeItem as removeHistoryItem, getHistory } from '../utils/SearchHistory'
import {ArrowRight} from '@material-ui/icons/ArrowRight'
import {Typography} from '@material-ui/core';
import moment from 'moment'
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import './index.css'

const responsive = {
  superLargeDesktop: {
    // the naming can be any, depends on you.
    breakpoint: { max: 4000, min: 3000 },
    items: 6,
    partialVisibilityGutter: 40 // this is needed to tell the amount of px that should be visible.
  
  },
  desktop: {
    breakpoint: { max: 3000, min: 1024 },
    items: 3,
    // partialVisibilityGutter: 50 // this is needed to tell the amount of px that should be visible.

  },
  tablet: {
    breakpoint: { max: 1024, min: 480 },
    items: 2,
    partialVisibilityGutter: 30 // this is needed to tell the amount of px that should be visible.

  },
  mobile: {
    breakpoint: { max: 480, min: 0 },
    items: 1,
    partialVisibilityGutter: 0 // this is needed to tell the amount of px that should be visible.

  }
};



 function RecentSearches(props) {
  useEffect(()=>{
    let RecentSearches= getHistory();
    const {dispatch}=props;
    dispatch({type:'SET_SEARCH_HISTORY',data:RecentSearches})
  },[])

 const removeItem=(e,item)=>
  {
    e.stopPropagation();
    let RecentSearches= removeHistoryItem(item);
    const {dispatch}=props;
    dispatch({type:'SET_SEARCH_HISTORY',data:RecentSearches})
  }
  const handleClick=(item)=>
  {
 return props?.onSelect(item)
  }
const {searches}=props;
  return (   
    <> 
    
     
    {searches&&searches.length>0&&<div className="recent-searches"> 
 <Typography variant="h6" style={{color:'var(--darker)',textTransform:'capitalize',textAlign:'left',marginTop:'20px'}}> Recent Searches</Typography>

      {/* <div className="recent-search-box"> */}
 
     <Carousel swipeable  responsive={responsive}  partialVisible={true}
     >
            {
              searches&&searches.length?searches.map((item,i)=><div key={i} className="recent-search" onClick={()=>handleClick(item)}>
              <div style={{borderBottom:'1px solid var(--backgroundcolor)',padding:'20px 20px 5px 20px'}}>
               <div style={{display:'inline-block',width:'45%',textAlign:'left'}}>
                 <Typography  className="mini-light-label">FROM</Typography>
                 <Typography  className="light-label clipped-label" >{item.start.name}</Typography>
                 <Typography className="mini-light-label clipped-label">{item.start.code}</Typography>
               </div>
               <div style={{display:'inline-block',width:'10%',textAlign:'center',position:'relative'}}> <Typography  style={{fontSize:'12px',color:'var(--darker)',position:'absolute',bottom:'50%'}}>{flightIcon}</Typography>
               </div>
               <div style={{display:'inline-block',width:'45%',textAlign:'right'}}>
               <Typography  className="mini-light-label">TO</Typography>
                 <Typography className="light-label clipped-label">{item.end.name}</Typography>
                 <Typography  className="mini-light-label clipped-label">{item.end.code}</Typography>
               </div>
              </div>
     
              <div style={{borderBottom:'1px solid var(--backgroundcolor)',padding:'10px 20px 5px 20px'}}>
               <div style={{display:'inline-block',width:'50%',textAlign:'left'}}>
                 <Typography  className="mini-light-label">TRAVEL DATE</Typography>
                 <Typography  className="light-label">{item.arrivalDate?moment(item.arrivalDate).format('DD-MM-YYYY'):'N/A'}</Typography>
               </div>
              
               <div style={{display:'inline-block',width:'50%',textAlign:'right'}}>
                 {item.journey_type=="Return"&&
             <>  <Typography  className="mini-light-label">RETURN</Typography>
               <Typography  className="light-label">{item.departureDate?moment(item.departureDate).format('DD-MM-YYYY'):'N/A'}</Typography></>}
               </div>
              </div>
     
              <div >
               <div style={{display:'inline-block',width:'50%',textAlign:'left'}}>
                 <div style={{padding:'10px 20px 20px 20px'}}>
                 <Typography  className="mini-light-label">TRAVELLER</Typography>
                 <Typography  className="light-label"> {item.adults||0} Adults, {item.kids||0} Children,  {item.infants||0} Infants
        </Typography>
                 </div>
               </div>
              
               <div style={{display:'inline-block',width:'50%',textAlign:'right',borderLeft:'1px solid var(--backgroundcolor)'}}>
               <div style={{padding:'10px 20px 20px 20px'}}>
            <Typography  className="mini-light-label">CLASS</Typography>
               <Typography  className="light-label">{item.flightClass||"Any"}</Typography>
               </div>
               </div>
              </div>
     
     
     
               {/* {item.start.name} - {item.end.name}  */}
               {/* <a className="icon-close" onClick={(e)=>removeItem(e,item)}>X</a> */}
               
               </div>):[]
            }
          </Carousel>
      {/* </div> */}
    
    </div>
  }</>
  );
}

const mapStateWithProps = (state) => ({
  searches: state.searchHistory.searches
});

export default React.memo(connect(mapStateWithProps)(RecentSearches));

const flightIcon=<a style={{transform:'rotate(90deg)',display:'block'}}><svg xmlns="http://www.w3.org/2000/svg" height="20" viewBox="0 0 24 24" width="20" fill="var(--darker)"><path d="M0 0h24v24H0z" fill="none"/><path d="M21 16v-2l-8-5V3.5c0-.83-.67-1.5-1.5-1.5S10 2.67 10 3.5V9l-8 5v2l8-2.5V19l-2 1.5V22l3.5-1 3.5 1v-1.5L13 19v-5.5l8 2.5z"/></svg></a>